import * as excel from '../excel-v3/initialState';
import * as json from '../json/initialState';
import * as servicenow from '../service-now/initialState';
import * as aws from '../aws/initialState';
import * as azure from '../azure/initialState';
import * as unified from '../unified/initialState';
import * as signavioExporter from '../signavio-exporter/initalState';
import * as celonisExporter from '../celonis-exporter/initialState';
import * as itpedia from '../ITPedia/initalState';
import * as servicenowGuidedExporter from '../servicenow-guided-exporter/initialState';
import { IntegrationId } from './streams/tabularMappings/types';
import { IntegrationInitialState } from './initialStateTypes';

export const integrationInitialStates: Record<
  IntegrationId,
  IntegrationInitialState
> = {
  'excel-v3': excel.initialState,
  'json-importer': json.initialState,
  'servicenow-v3': servicenow.initialState,
  'azure-v3': azure.initialState,
  'aws-v3': aws.initialState,
  'signavio-exporter': signavioExporter.initialState,
  'servicenow-guided-exporter': servicenowGuidedExporter.initialState,
  'it-pedia': itpedia.initialState,
  'celonis-exporter': celonisExporter.initialState,
  ...unified.initialStates,
};
